const initalState = null;
const submissionTransmittalDetailReducer = (state = initalState, action) => {
  const { type, data } = action;
  switch (type) {
    case "ADD_TRANSMITTAL_SUBMISSION_VALUE":
      return data;
    default:
      return state;
  }
};

const submissionTransmittalSoftCopyDetailReducer = (
  state = initalState,
  action
) => {
  const { type, data } = action;
  switch (type) {
    case "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE":
      return data;
    default:
      return state;
  }
};

const submissionTransmittalCommentReducer = (state = initalState, action) => {
  const { type, data } = action;
  switch (type) {
    case "ADD_TRANSMITTAL_COMMENT_SUBMISSION_VALUE":
      return data;
    default:
      return state;
  }
};

export {
  submissionTransmittalDetailReducer,
  submissionTransmittalCommentReducer,
  submissionTransmittalSoftCopyDetailReducer,
};
